import { Typography } from '@mui/material';
import React from 'react';
import {
  ArrayField,
  ArrayInput,
  AutocompleteInput,
  BooleanField,
  BooleanInput,
  Datagrid,
  ReferenceField,
  ReferenceInput,
  ShowButton,
  SimpleFormIterator,
  TextField,
} from 'react-admin';

export const ListCoachClients: React.FC = () => {
  return (
    <>
      <Typography variant="h5" fontSize={20}>
        Clients
      </Typography>
      <ArrayField resource="Client" source="coachData.coachClients.edges">
        <Datagrid resource="Client" bulkActionButtons={false} rowClick={false}>
          <TextField source="node.displayName" label="Name" />
          <BooleanField source="availableForAssignment" />
          <BooleanField source="supportsWellbeingCoaching" />
          <BooleanField source="supportsHighPerformanceCoaching" />

          <ReferenceField reference="Client" source="node.id" label="">
            <ShowButton />
          </ReferenceField>
        </Datagrid>
      </ArrayField>
    </>
  );
};

export const EditCoachClients: React.FC = () => {
  return (
    <>
      <Typography variant="h5" fontSize={20}>
        Clients
      </Typography>
      <ArrayInput
        resource="Client"
        source="coachData.coachClients.edges"
        label=""
        validate={(values) => {
          if (
            values.some(
              (value: { node: { id: string | undefined } }) => !value.node.id,
            )
          ) {
            return 'All rows must have a client selected. Select a client or remove any empty rows.';
          }
          return undefined;
        }}
        data-testid="coach-clients-array-input"
      >
        <SimpleFormIterator inline disableReordering>
          <ReferenceInput
            source="node.id"
            reference="Client"
            filterToQuery={(name: string) => ({
              name,
            })}
          >
            <AutocompleteInput
              label="Name"
              optionText="name"
              filter="name"
              sx={{
                minWidth: '300px',
              }}
              data-testid="client-autocomplete"
            />
          </ReferenceInput>
          <BooleanInput
            source="availableForAssignment"
            sx={{ alignSelf: 'center' }}
          />

          <BooleanInput
            source="supportsWellbeingCoaching"
            sx={{ alignSelf: 'center' }}
            data-testid="supports-wellbeing-coaching"
          />
          <BooleanInput
            source="supportsHighPerformanceCoaching"
            sx={{ alignSelf: 'center' }}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};
